import { sharedChargeSchema } from 'templates/Charge/sharedCharge.schema'
import * as yup from 'yup'

export const FormProductSchema = yup.object({
  namePlan: yup.string().required('Nome do produto é obrigatório.'),
  icon: yup.string().when('documentUuid', {
    is: (value: any) => value == undefined,
    then: yup.string().required('Ícone do produto é obrigatório.')
  }),
  days: yup.string().when('issue_when', {
    is: 'on_custom_issued',
    then: yup.string().required('Prazo em dias é obrigatório.'),
    otherwise: yup.string().notRequired()
  }),
  amount: yup
    .string()
    .typeError('Valor obrigatório.')
    .required('Valor obrigatório.'),
  description: yup.string(),
  billingDescription: yup.string(),
  documentUuid: yup.string(),
  discountPolicy: yup.boolean(),
  dayDate: yup.number(),
  interestPolicy: yup.boolean(),
  status: yup.number(),
  chargeType: yup.number().default(0)
})

// Combined schema for products (includes shared charge fields)
export const CombinedProductSchema =
  FormProductSchema.concat(sharedChargeSchema)

// Use the combined schema for type inference to include discounts field
export type FormProductParams = yup.InferType<typeof CombinedProductSchema>
